module.exports = __webpack_public_path__ + "img/logo-ostpstviewer.8acb63a.png";